import React, { FC } from 'react';
import CTA from '../../../@shared/CTA';
import ctaTypes from '../../../../enums/CTA.enums';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TLinkField } from '../../../../types/sitecore.types';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import './styles.scss';

export type TProductHeaderSection = {
  findProduct: TLinkField;
};

const ProductHeaderSection: FC<TProductHeaderSection> = (props) => {
  const { findProduct } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  return (
    <div className="product-dashboard-findProduct">
      {findProduct?.value?.title && (
        <Text tag="p" field={{ value: findProduct?.value?.title }} className="product-dashboard-findProduct__label" editable={true} />
      )}
      {findProduct && <CTA type={ctaTypes.primaryWhite} target={targetLinkdsk(findProduct, isDesktop)} field={findProduct} />}
    </div>
  );
};

export default React.memo(ProductHeaderSection);
